import type { ButtonStandardProps } from ".";
import type { ColorShade } from "../../../theme";

export const getIconColor = (
	variant: ButtonStandardProps["variant"] = "solid",
	color: ButtonStandardProps["color"] = "primary"
): ColorShade => {
	if (variant === "solid") {
		return "neutral-0";
	} else if (variant === "outline") {
		if (color === "primary") {
			return "primary-5";
		}
		return "neutral-7";
	} else if (variant === "micro") {
		return "neutral-9";
	} else if (variant === "text" && color) {
		return `${color}-5`;
	}
	return "neutral-5";
};

export const getButtonIconSize = (size: ButtonStandardProps["size"]) => (size === "small" ? 12 : 16);
